import type React from 'react';

import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';

import { BiometricIdentificationCard } from './BiometricIdentificationCard';
import st from './CreateHandlerPage.module.sass';
import { CreateHandlerPageHeader } from './CreateHandlerPageHeader';
import { DefineAttributesCard } from './DefineAttributesCard';
import { OtherHandlerCard } from './OtherHandlerCard';

function CreateHandlerPage(): React.JSX.Element {
  return (
    <Page className={st.Page}>
      <PageContent>
        <CreateHandlerPageHeader />
        <div className={st.Grid}>
          <BiometricIdentificationCard />
          <DefineAttributesCard />
          <OtherHandlerCard />
        </div>
      </PageContent>
    </Page>
  );
}

export default CreateHandlerPage;
